import Joi from 'joi';

export const CreateResellerSchema = Joi.object({
  entityName: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Reseller name is required.',
    'string.base': 'Reseller name is invalid.',
    'string.empty': 'Reseller name is invalid.',
    'string.min': 'Reseller name can be at most 64 characters only.',
    'string.max': 'Reseller name can be at most 64 characters only.',
  }),
  email: Joi.string().trim().max(100).required().messages({
    'any.required': 'Email is required.',
    'string.base': 'Email is invalid.',
    'string.empty': 'Email is invalid.',
    'string.min': 'Email must have at most 100 characters only.',
    'string.max': 'Email must have at most 100 characters only.',
  }),
  partnerId: Joi.number().optional().messages({
    'any.only': 'Partner is invalid.',
    'number.base': 'Partner is invalid.',
  }),
});

export const AdminCreateResellerSchema = Joi.object({
  entityName: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Reseller name is required.',
    'string.base': 'Reseller name is invalid.',
    'string.empty': 'Reseller name is invalid.',
    'string.min': 'Reseller name can be at most 64 characters only.',
    'string.max': 'Reseller name can be at most 64 characters only.',
  }),
  email: Joi.string().trim().max(100).required().messages({
    'any.required': 'Email is required.',
    'string.base': 'Email is invalid.',
    'string.empty': 'Email is invalid.',
    'string.min': 'Email must have at most 100 characters only.',
    'string.max': 'Email must have at most 100 characters only.',
  }),
  partnerId: Joi.number().required().messages({
    'any.only': 'Partner is invalid.',
    'any.required': 'Partner is required.',
    'number.base': 'Partner is invalid.',
  }),
});
